import type { ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { TextAreaWithCounter } from "@/react/pages/BotBuilder/BehaviorPage/TextAreaWithCounter";
import { Form } from "@circle-react-uikit/Form";
import { useCurrentAction } from "../../../ActionRule";
import { useDefaultValueForField } from "../../../useDefaultValueforField";
import "./styles.scss";

export const FormRenamePostTitle = () => {
  const { paramsPath } = useCurrentAction();

  const { getValues, setValue } = useFormContext();

  const instructions = getValues(`${paramsPath}.instructions`) as string | null;

  useDefaultValueForField(`${paramsPath}.instructions`, "");

  return (
    <div className="workflows-form-rename-post-title flex flex-col gap-5">
      <Form.Item
        name={`${paramsPath}.instructions`}
        hideBorder
        fullWidth
        hideDescription
        label={
          <div className="mb-0.5 flex items-center gap-[3px]">
            <Icon type="20-ai-prompt" size={20} className="mr-1" />
            <span>{t("settings.workflows.form.instructions")} </span>
            <TippyV2
              content={t("settings.workflows.form.instructions_description")}
              className="flex"
            >
              <Icon
                type="16-question-mark"
                size={16}
                useWithStrokeCurrentColor
              />
            </TippyV2>
          </div>
        }
        labelClassName="!mb-2 !text-sm"
        className="!py-0"
        placeholder={t("settings.workflows.form.instructions_placeholder")}
        rules={{
          required: false,
        }}
      >
        <TextAreaWithCounter
          value={instructions}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setValue(`${paramsPath}.instructions`, e.target.value)
          }
          name={`${paramsPath}.instructions`}
          rows={8}
          maxLength={500}
        />
      </Form.Item>
    </div>
  );
};
